module.exports = __webpack_public_path__ + "static/media/about_bg1.1bdc532a.jpg";